/* Lockett Labs Events: the vendor dashboard.
   One trader's application, behind the private link in our emails. The
   token arrives in the address fragment (#portal=...), is kept for this tab
   (or on this device, if they ask), taken out of the address bar at once, and
   sent to the events desk in a header, never in a URL a server logs.
   Everything the desk sends back is put on the page as text, never HTML. */
(function () {
  'use strict';
  var EV = window.EV;
  var root = document.querySelector('[data-ev-vendor]');
  if (!EV || !root) return;
  var el = EV.el;
  var icon = EV.icon;
  var API = EV.apiBase(root.getAttribute('data-api') || '');
  var APPLY = root.getAttribute('data-apply-url') || '/pages/events?view=vendor-apply';
  var DIR = root.getAttribute('data-dir-url') || '/pages/events?view=event-vendors';
  var TRADERS = root.getAttribute('data-traders-url') || '/pages/event-traders';
  var TOKEN_KEY = 'll_ev_portal';
  var KEEP_KEY = 'll_ev_portal_keep';
  var gate = root.querySelector('[data-evd-gate]');
  var loading = root.querySelector('[data-evd-loading]');
  var app = root.querySelector('[data-evd-app]');
  var SHOWS = {};
  try { SHOWS = JSON.parse((root.querySelector('[data-evd-shows]') || {}).textContent || '{}'); } catch (e) { SHOWS = {}; }
  var token = '';
  var A = null;           // the application, as the desk last sent it
  var tab = 'overview';
  var TABS = [
    ['overview', 'Overview', 'dash'], ['messages', 'Messages', 'chat'], ['booking', 'Booking & pay', 'ticket'],
    ['showday', 'Show day', 'stall'], ['kit', 'Promo kit', 'poster'], ['group', "Traders' group", 'whatsapp'], ['profile', 'Profile', 'users']
  ];
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* ================================================================ helpers */
  // This trader's short link, landing on the show's trader list:
  // events.lockett-labs.com/<show>/<the end of their reference>#traders
  function traderShort(a) {
    var h = a && a.event && a.event.handle, code = String((a && a.ref) || '').split('-').pop();
    return EV.SHORT && h && /^[A-Za-z0-9]{4,10}$/.test(code) ? EV.SHORT + '/' + h + '/' + code + '#traders' : '';
  }
  function btn(label, cls, onclick, ic, after) {
    var b = el('button', { type: 'button', class: 'ev-btn ' + (cls || '') });
    if (ic && !after) b.append(icon(ic));
    b.append(label);
    if (ic && after) b.append(icon(ic, 'ev-arr'));
    if (onclick) b.addEventListener('click', onclick);
    return b;
  }
  function card(title, cls, ic) {
    var c = el('section', { class: 'evd-card ' + (cls || '') });
    if (title) c.append(el('h2', { class: 'evd-card__h' }, ic ? icon(ic) : null, title));
    return c;
  }
  function niceDate(iso, opts) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', opts || { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
  }
  function when(iso) {
    var d = new Date(iso);
    return isNaN(d.getTime()) ? '' : d.toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  }
  function daysTo(iso) {
    var d = iso ? new Date(iso) : null;
    if (!d || isNaN(d.getTime())) return null;
    var a = new Date(); a.setHours(0, 0, 0, 0);
    var b = new Date(d); b.setHours(0, 0, 0, 0);
    return Math.round((b - a) / 86400000);
  }
  function show() { return (A && A.event && SHOWS[A.event.handle]) || {}; }
  function portal(path, opts) { return EV.api(API, 'portal.php?action=' + path, Object.assign({ token: token }, opts || {})); }
  function isDone(k) { return A && (A.done || []).indexOf(k) > -1; }
  var STATUS = {
    pending: ['In review', 'is-review'], info_requested: ['Waiting on you', 'is-wait'], approved: ['Table offered', 'is-offered'],
    waitlisted: ['Reserve list', 'is-reserve'], declined: ['Not this time', 'is-closed'], withdrawn: ['Withdrawn', 'is-closed'], cancelled: ['Cancelled', 'is-closed']
  };
  function statusOf(a) { return a.confirmed ? ['Confirmed', 'is-confirmed'] : (STATUS[a.status] || [a.statusLabel, 'is-closed']); }
  function unpaid(a) { return (a.invoices || []).filter(function (i) { return i.status === 'issued' || i.status === 'overdue'; }); }
  function safe(u, re) { return re.test(u || '') ? u : ''; }

  /* ================================================================ signing in and out */
  function takeHashToken() {
    var m = location.hash.match(/^#portal=([A-Za-z0-9_-]{40,60})(?:&tab=([a-z]+))?$/);
    if (!m) return false;
    token = m[1];
    try { sessionStorage.setItem(TOKEN_KEY, token); if (localStorage.getItem(KEEP_KEY)) localStorage.setItem(KEEP_KEY, token); } catch (e) { /* storage blocked */ }
    if (m[2]) tab = m[2];
    // Out of the address bar straight away: not bookmarked, screenshotted or shared by accident.
    history.replaceState(null, '', location.pathname + location.search + '#tab=' + tab);
    return true;
  }
  function savedToken() {
    try { return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(KEEP_KEY) || ''; } catch (e) { return ''; }
  }
  function signOut() {
    try { sessionStorage.removeItem(TOKEN_KEY); localStorage.removeItem(KEEP_KEY); } catch (e) { /* ignore */ }
    token = '';
    A = null;
    app.hidden = true;
    app.textContent = '';
    showGate('Signed out on this device. Your link in your email still works.');
  }
  function showGate(note, bad) {
    loading.hidden = true;
    app.hidden = true;
    gate.hidden = false;
    var n = gate.querySelector('[data-evd-gate-note]');
    if (note && n) { n.textContent = note; n.classList.toggle('is-bad', !!bad); }
  }
  var linkForm = root.querySelector('[data-evd-linkform]');
  if (linkForm) {
    linkForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = linkForm.querySelector('input[type=email]');
      var msg = linkForm.querySelector('[data-evd-linkmsg]');
      var b = linkForm.querySelector('button[type=submit]');
      msg.hidden = true;
      if (!EMAIL.test(input.value.trim())) { msg.hidden = false; msg.className = 'evf-err'; msg.textContent = 'Enter the email you applied with.'; input.focus(); return; }
      b.classList.add('is-busy');
      EV.api(API, 'public.php?action=portal-link', { method: 'POST', body: { email: input.value.trim() } })
        .then(function (r) { msg.hidden = false; msg.className = 'ev-form-ok'; msg.textContent = r.message; })
        .catch(function (err) { msg.hidden = false; msg.className = 'ev-form-bad'; msg.textContent = err.message; })
        .then(function () { b.classList.remove('is-busy'); });
    });
  }

  /* ================================================================ loading */
  function load(first) {
    if (first) { loading.hidden = false; gate.hidden = true; }
    return portal('me').then(function (r) { render(r.application); }).catch(function (err) {
      if (err.status === 401) {
        try { sessionStorage.removeItem(TOKEN_KEY); localStorage.removeItem(KEEP_KEY); } catch (e) { /* ignore */ }
        token = '';
        showGate('That link has expired or is not right. Enter your email and we will send a fresh one.', true);
      } else if (first) {
        showGate(err.message, true);
      } else EV.toast(err.message);
    });
  }
  function track(what) {
    if (isDone(what) && what !== 'kit' && what !== 'share') return;
    portal('track', { method: 'POST', body: { what: what } }).then(function (r) {
      A = r.application;
      paintTop();
      paintTabs();
    }).catch(function () { /* a missed tick is not worth an error */ });
  }

  /* ================================================================ the frame */
  var topEl, tabsEl, bodyEl;
  function render(a) {
    A = a;
    loading.hidden = true;
    gate.hidden = true;
    app.hidden = false;
    if (!topEl) {
      topEl = el('header', { class: 'evd-top' });
      tabsEl = el('nav', { class: 'evd-tabs', 'aria-label': 'Dashboard' });
      bodyEl = el('div', { class: 'ev-wrap evd-body', id: 'evd-body', tabindex: '-1' });
      app.append(topEl, el('div', { class: 'evd-tabs__wrap' }, el('div', { class: 'ev-wrap' }, tabsEl)), bodyEl);
    }
    paintTop();
    paintTabs();
    paintBody();
  }
  function paintTop() {
    var a = A, sh = show(), st = statusOf(a), ev = a.event || {};
    topEl.textContent = '';
    if (sh.banner) topEl.style.setProperty('--evd-art', 'url("' + sh.banner.replace(/"/g, '') + '")');
    var days = daysTo(ev.startsAt);
    var count = null;
    if (days != null && ['declined', 'withdrawn', 'cancelled'].indexOf(a.status) === -1) {
      count = el('div', { class: 'evd-count' + (days <= 7 && days >= 0 ? ' is-soon' : '') },
        el('small', { text: days > 0 ? 'Show day in' : days === 0 ? 'Show day' : 'Show was' }),
        el('b', { text: days > 1 ? days + ' days' : days === 1 ? 'Tomorrow' : days === 0 ? 'Today' : Math.abs(days) + ' days ago' }),
        el('span', { text: niceDate(ev.startsAt, { weekday: 'short', day: 'numeric', month: 'short' }) }));
    }
    var tier = a.tier ? el('span', { class: 'evx-tier is-' + a.tier.key }, icon(a.tier.key === 'headline' ? 'crown' : 'star'), a.tier.name) : null;
    var acts = el('div', { class: 'evd-top__acts' });
    var wa = safe(a.team && a.team.whatsapp, /^https:\/\/wa\.me\//);
    if (wa) acts.append(el('a', { class: 'ev-btn ev-btn--sm ev-btn--wa', href: wa, target: '_blank', rel: 'noopener' }, icon('whatsapp'), 'Message the team'));
    if (sh.url) acts.append(el('a', { class: 'ev-btn ev-btn--sm', href: sh.url }, icon('ext'), 'Show page'));
    topEl.append(el('div', { class: 'ev-wrap evd-top__in' },
      el('div', { class: 'evd-id' }, EV.vendorLogo({ logo: a.business.logo, initials: (a.business.name || '?').slice(0, 2).toUpperCase(), name: a.business.name || 'Your table' }, 'evx-vlogo evd-id__logo'),
        el('div', { class: 'evd-id__tx' },
          el('span', { class: 'ev-kicker is-gold', text: ev.title ? ev.title + (ev.dateLabel ? ' · ' + ev.dateLabel : '') : 'Your application' }),
          el('h1', { class: 'ev-display', text: a.business.name || 'Your table' }),
          el('div', { class: 'evd-id__meta' }, el('span', { class: 'evd-pill ' + st[1], text: st[0] }), tier, el('span', { class: 'evd-ref', text: a.ref })))),
      el('div', { class: 'evd-top__side' }, count, acts)));
  }
  function badge(id) {
    var a = A;
    if (id === 'messages') { var q = a.status === 'info_requested'; return q ? '!' : ''; }
    if (id === 'booking') return unpaid(a).length ? '£' : '';
    if (id === 'group') return a.whatsapp && a.whatsapp.state === 'open' && !isDone('whatsapp') ? '1' : '';
    return '';
  }
  function locked(id) {
    if (id === 'kit' || id === 'showday') return A.status !== 'approved';
    if (id === 'group') return !A.whatsapp || A.whatsapp.state !== 'open';
    return false;
  }
  function paintTabs() {
    tabsEl.textContent = '';
    TABS.forEach(function (t) {
      var b = el('a', { href: '#tab=' + t[0], class: 'evd-tab' + (tab === t[0] ? ' is-on' : '') + (locked(t[0]) ? ' is-locked' : ''), 'aria-current': tab === t[0] ? 'page' : null }, icon(t[2]), el('span', { text: t[1] }));
      var bd = badge(t[0]);
      if (bd) b.append(el('i', { class: 'evd-tab__badge', text: bd }));
      tabsEl.append(b);
    });
    var on = tabsEl.querySelector('.is-on');
    if (on && on.scrollIntoView && tabsEl.scrollWidth > tabsEl.clientWidth) on.scrollIntoView({ inline: 'center', block: 'nearest' });
  }
  function go(t, focus) {
    if (!TABS.some(function (x) { return x[0] === t; })) t = 'overview';
    tab = t;
    if (location.hash !== '#tab=' + t) history.replaceState(null, '', location.pathname + location.search + '#tab=' + t);
    paintTabs();
    paintBody();
    if (focus) {
      var top = app.getBoundingClientRect().top + window.scrollY + topEl.offsetHeight - 12;
      if (window.scrollY > top) window.scrollTo({ top: top, behavior: EV.reduce.matches ? 'auto' : 'smooth' });
      bodyEl.focus({ preventScroll: true });
    }
  }
  window.addEventListener('hashchange', function () {
    if (takeHashToken()) { load(true); return; }
    var m = location.hash.match(/^#tab=([a-z]+)$/);
    if (m && A && m[1] !== tab) go(m[1], true);
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-evd-go]');
    if (t) { e.preventDefault(); go(t.getAttribute('data-evd-go'), true); }
  });

  function paintBody() {
    bodyEl.textContent = '';
    var fn = { overview: tabOverview, messages: tabMessages, booking: tabBooking, showday: tabShowday, kit: tabKit, group: tabGroup, profile: tabProfile }[tab] || tabOverview;
    fn(bodyEl);
  }

  /* ================================================================ overview */
  function nextStep(a) {
    var ho = a.handover || {};
    // a table passed to them: setting up comes before anything else
    if (ho.setup) return { title: 'This table is yours now', text: 'A trader passed their table' + (a.event && a.event.title ? ' at ' + a.event.title : '') + ' to you and the team approved it' + (ho.paidBefore ? '. It is already paid for.' : '.') + ' Add your details and accept the trader terms to finish setting up.', label: 'Add your details', go: 'booking', tone: 'pay' };
    if (ho.request) return { title: 'Waiting for the team', text: 'You have asked to pass your table to ' + ho.request.toBusiness + ' (' + ho.request.toEmail + '). It stays yours until the team approves it, and you can still cancel.', label: 'See your request', go: 'booking', tone: 'wait' };
    var inv = unpaid(a)[0];
    var wa = a.whatsapp || {};
    var lastQ = (a.messages || []).slice().reverse().filter(function (m) { return m.kind === 'info_request'; })[0];
    if (a.status === 'info_requested') return { title: 'We have a question for you', text: lastQ ? lastQ.body : 'Reply from Messages and it comes straight to us.', label: 'Answer it', go: 'messages', tone: 'wait' };
    if (a.status === 'approved' && inv) return { title: 'Pay to confirm your table', text: 'Invoice ' + inv.number + ' for ' + EV.money(inv.balance) + (inv.dueDate ? ', due ' + niceDate(inv.dueDate, { day: 'numeric', month: 'long' }) : '') + '. Your table is held once it is paid.', label: 'Pay ' + EV.money(inv.balance), go: 'booking', tone: 'pay' };
    if (a.status === 'approved' && !a.confirmed) return { title: 'Your table is offered', text: 'Your invoice is on its way by email. In the meantime, set up your listing and look at your promo kit.', label: 'Open your promo kit', go: 'kit' };
    if (a.confirmed && wa.state === 'open' && !isDone('whatsapp')) return { title: 'Join the traders\' group', text: 'Every trader at the show is in one WhatsApp group with the team: set-up news, lifts, parking and swaps.', label: 'Join on WhatsApp', go: 'group', tone: 'wa' };
    if (a.status === 'approved' && !isDone('kit')) return { title: 'Make your posters', text: 'Posters drawn with your logo for Instagram, stories, Facebook and print. The more you share, the busier your table.', label: 'Open your promo kit', go: 'kit' };
    if (a.status === 'approved' && !isDone('info')) return { title: 'Check your show-day details', text: 'Arrival, your table and packing down, all in one place.', label: 'Show day', go: 'showday' };
    if (a.status === 'approved' && (!a.business.logo || !a.blurb)) return { title: 'Finish your listing', text: 'Add your logo and a line about you: visitors see them on the show page.', label: 'Edit your listing', go: 'profile' };
    if (a.confirmed) return { title: 'You are all set', text: 'Confirmed and ready. We will send the run-down a week before, and the short list the night before.', label: 'See show day', go: 'showday', tone: 'done' };
    if (a.status === 'pending') return { title: 'We are reading your application', text: 'We read every one ourselves and reply by email, usually within a week. You can still change your details from Booking.', label: !a.business.logo || !a.blurb ? 'Finish your listing' : 'Your details', go: !a.business.logo || !a.blurb ? 'profile' : 'booking' };
    if (a.status === 'waitlisted') return { title: 'You are on the reserve list', text: 'Every table is taken right now. If one comes free, you hear first.', label: 'Message the team', go: 'messages' };
    return { title: a.status === 'declined' ? 'Not this time' : a.status === 'withdrawn' ? 'Application withdrawn' : 'Booking cancelled', text: 'Thank you for applying. New dates open for applications on the Trade with us page.', label: 'Apply for another show', href: APPLY };
  }
  function tabOverview(body) {
    var a = A, n = nextStep(a), st = statusOf(a);
    var stepper = el('ol', { class: 'evd-steps' });
    var hist = {};
    (a.history || []).forEach(function (h) { hist[h.key] = h.when; });
    var at = { received: hist.received, review: hist.review || hist.info, decision: hist.offered || hist.waitlisted || hist.declined || hist.withdrawn || hist.cancelled, invoice: hist.invoice, confirmed: hist.confirmed, handover: hist.handover, details: hist.details };
    (a.timeline || []).forEach(function (s) {
      if (s.skip) return;
      stepper.append(el('li', { class: s.done ? 'is-done' : s.current ? 'is-now' : '' }, el('i', null, s.done ? icon('check') : null), el('b', { text: s.label }), at[s.key] && s.done ? el('small', { text: niceDate(at[s.key], { day: 'numeric', month: 'short' }) }) : null));
    });
    var action = n.href ? el('a', { class: 'ev-btn ev-btn--primary', href: n.href }, n.label, icon('arrow', 'ev-arr'))
      : btn(n.label, n.tone === 'wa' ? 'ev-btn--wa' : 'ev-btn--primary', function () { go(n.go, true); }, 'arrow', true);
    body.append(el('section', { class: 'evd-hero ' + st[1] + (n.tone ? ' tone-' + n.tone : '') },
      el('div', { class: 'evd-hero__tx' }, el('span', { class: 'evd-hero__k', text: 'Next step' }), el('h2', { class: 'ev-display', text: n.title }), el('p', { text: n.text }), action),
      el('div', { class: 'evd-hero__rail' }, stepper)));

    // the tiles
    var tiles = el('div', { class: 'evd-tiles' });
    var tbl = a.booking.zone || a.booking.tableNo ? [a.booking.zone, a.booking.tableNo ? 'Table ' + a.booking.tableNo : ''].filter(Boolean).join(' · ') : a.status === 'approved' ? 'Allocated soon' : '—';
    var inv = unpaid(a)[0];
    // a table passed on may have been paid for before it was theirs
    var paidAll = ((a.invoices || []).length && !inv) || (a.handover && a.handover.paidBefore && !inv);
    var wa = a.whatsapp || {};
    tiles.append(
      tile('Your table', tbl, a.status === 'approved' ? 'showday' : '', 'stall', a.booking.tableNo ? 'is-teal' : ''),
      tile('Invoice', inv ? EV.money(inv.balance) + ' due' : paidAll ? 'Paid' : a.status === 'approved' ? 'On its way' : '—', 'booking', 'pound', inv ? 'is-hot' : paidAll ? 'is-ok' : ''),
      tile("Traders' group", wa.state === 'open' ? (isDone('whatsapp') ? 'Joined' : 'Join now') : wa.state === 'locked' ? 'Locked' : '—', wa.state === 'open' ? 'group' : '', 'whatsapp', wa.state === 'open' && !isDone('whatsapp') ? 'is-wa' : isDone('whatsapp') ? 'is-ok' : ''),
      tile('Promo kit', a.status === 'approved' ? (isDone('kit') ? 'Posters made' : 'Ready') : 'With a table', a.status === 'approved' ? 'kit' : '', 'poster', a.status === 'approved' && !isDone('kit') ? 'is-hot' : isDone('kit') ? 'is-ok' : '')
    );
    body.append(tiles);

    var grid = el('div', { class: 'evd-grid' });
    var left = el('div', { class: 'evd-col' }), right = el('div', { class: 'evd-col' });
    grid.append(left, right);
    body.append(grid);

    // checklist
    if ((a.checklist || []).length) {
      var cl = card('Your checklist', 'evd-check', 'check');
      var total = a.checklist.length, doneN = a.checklist.filter(function (c) { return c.done; }).length;
      cl.append(el('div', { class: 'evd-check__bar' }, el('i', { style: 'width:' + Math.round(doneN / total * 100) + '%' }), el('span', { text: doneN + ' of ' + total + ' done' })));
      var ul = el('ul', { class: 'evd-check__list' });
      a.checklist.forEach(function (c) {
        var row = el(c.tab && !c.done ? 'button' : 'div', { class: 'evd-check__i' + (c.done ? ' is-done' : '') + (c.locked ? ' is-locked' : ''), type: c.tab && !c.done ? 'button' : null },
          el('i', null, c.done ? icon('check') : c.locked ? icon('lock') : null),
          el('span', null, el('b', { text: c.label }), c.note ? el('small', { text: c.note }) : null),
          c.tab && !c.done && !c.locked ? icon('arrow') : null);
        if (c.tab && !c.done) row.addEventListener('click', function () { go(c.tab, true); });
        ul.append(el('li', null, row));
      });
      cl.append(ul);
      left.append(cl);
    }
    // announcements
    var an = card('From the team', 'evd-news', 'megaphone');
    if ((a.announcements || []).length) {
      a.announcements.forEach(function (x) {
        an.append(el('article', { class: 'evd-news__i' + (x.pinned ? ' is-pinned' : '') },
          el('div', { class: 'evd-news__top' }, x.pinned ? el('span', { class: 'evd-news__pin', text: 'Pinned' }) : null, el('time', { text: niceDate(x.at, { day: 'numeric', month: 'short' }) })),
          el('h3', { text: x.title }), el('p', { text: x.body })));
      });
    } else an.append(el('p', { class: 'ev-muted', text: 'Notes from the team for traders at your show appear here, and come by email too.' }));
    left.append(an);

    // history
    var hc = card('How it has moved', 'evd-hist', 'clock');
    var ol = el('ol', { class: 'evd-hist__list' });
    (a.history || []).slice().reverse().forEach(function (h) { ol.append(el('li', { class: 'is-' + h.key }, el('b', { text: h.label }), el('time', { text: when(h.when) }))); });
    hc.append(ol);
    right.append(hc);

    // other applications
    var oc = card('Your other applications', 'evd-apps', 'doc');
    oc.append(el('p', { class: 'ev-muted', text: 'Checking…' }));
    right.append(oc);
    portal('apps').then(function (r) {
      oc.querySelector('p').remove();
      if (!(r.apps || []).length) { oc.append(el('p', { class: 'ev-muted' }, 'Just this one. ', el('a', { href: APPLY, text: 'Apply for another show' }), '.')); return; }
      var ul2 = el('ul', { class: 'evd-apps__list' });
      r.apps.forEach(function (x) { ul2.append(el('li', null, el('span', null, el('b', { text: x.event || 'A show' }), el('small', { text: [x.date, x.ref].filter(Boolean).join(' · ') })), el('span', { class: 'evd-pill is-small', text: x.statusLabel }))); });
      oc.append(ul2, el('p', { class: 'ev-muted ev-small', text: 'Each has its own link, in the emails for that application.' }));
    }).catch(function () { oc.remove(); });
  }
  function tile(label, value, goTo, ic, cls) {
    var t = el(goTo ? 'button' : 'div', { class: 'evd-tile ' + (cls || ''), type: goTo ? 'button' : null }, el('span', { class: 'evd-tile__ic' }, icon(ic)), el('small', { text: label }), el('b', { text: value }));
    if (goTo) { t.append(icon('arrow', 'evd-tile__go')); t.addEventListener('click', function () { go(goTo, true); }); }
    return t;
  }

  /* ================================================================ messages */
  function tabMessages(body) {
    var a = A;
    var c = card('Messages', 'evd-msgs', 'chat');
    var lastQ = a.messages.slice().reverse().filter(function (m) { return m.kind === 'info_request'; })[0];
    if (a.status === 'info_requested' && lastQ) c.append(el('div', { class: 'evp-alert' }, el('b', { text: 'Our question: ' }), lastQ.body));
    var thread = el('div', { class: 'evd-thread', role: 'log', 'aria-live': 'polite' });
    if (!a.messages.length) thread.append(el('p', { class: 'ev-muted', text: 'Nothing yet. Questions about your table? Ask here and it comes straight to the team.' }));
    var lastDay = '';
    a.messages.forEach(function (m) {
      var day = niceDate(m.at, { weekday: 'long', day: 'numeric', month: 'long' });
      if (day !== lastDay) { thread.append(el('div', { class: 'evd-thread__day', text: day })); lastDay = day; }
      var sys = m.kind === 'invoice' || m.kind === 'payment' || m.kind === 'update' || m.kind === 'handover' || (m.kind === 'status' && m.from === 'you');
      var time = new Date(m.at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      if (sys) { thread.append(el('div', { class: 'evd-sys' }, el('span', { text: m.body + ' · ' + time }))); return; }
      var bubble = el('div', { class: 'evd-msg' + (m.from === 'you' ? ' is-you' : '') + (m.kind === 'info_request' ? ' is-q' : '') + (m.kind === 'status' ? ' is-status' : '') },
        el('small', { text: (m.from === 'you' ? 'You' : m.name) + ' · ' + time }), el('p', { text: m.body }));
      (m.files || []).forEach(function (f) { bubble.append(el('span', { class: 'evd-msg__file' }, icon('clip'), f.name)); });
      thread.append(bubble);
    });
    c.append(thread);
    var ta = el('textarea', { class: 'evf-textarea', placeholder: 'Write to the team', maxlength: 4000, 'aria-label': 'Your message', rows: 3 });
    var fileIn = el('input', { type: 'file', accept: 'application/pdf,image/png,image/jpeg,image/webp', 'aria-label': 'Attach a PDF or photo', class: 'ev-sr' });
    var pick = el('label', { class: 'evd-attach' }, icon('clip'), el('span', { text: 'Attach' }), fileIn);
    var chosen = el('span', { class: 'evd-chosen', hidden: true });
    var clearFile = function () { fileIn.value = ''; chosen.hidden = true; pick.hidden = false; };
    fileIn.addEventListener('change', function () {
      var f = fileIn.files[0];
      if (!f) { clearFile(); return; }
      if (f.size > 8 * 1024 * 1024) { clearFile(); EV.toast('Files must be under 8 MB'); return; }
      chosen.textContent = '';
      chosen.append(icon('doc'), el('span', { text: f.name }), el('button', { type: 'button', 'aria-label': 'Remove ' + f.name, text: '×', onclick: function () { clearFile(); } }));
      chosen.hidden = false;
      pick.hidden = true;
    });
    var send = btn('Send', 'ev-btn--primary', function () {
      if (!ta.value.trim() && !fileIn.files[0]) { ta.focus(); return; }
      var fd = new FormData();
      fd.append('body', ta.value);
      if (fileIn.files[0]) fd.append('file', fileIn.files[0]);
      send.classList.add('is-busy');
      portal('message', { method: 'POST', body: fd }).then(function (r) { EV.toast('Sent. We reply by email and here.'); render(r.application); })
        .catch(function (err) { send.classList.remove('is-busy'); EV.toast(err.message); });
    }, 'arrow', true);
    ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) send.click(); });
    c.append(el('div', { class: 'evd-compose' }, ta, el('div', { class: 'evd-compose__row' }, el('div', { class: 'evd-compose__att' }, pick, chosen), el('small', { class: 'ev-muted', text: 'Ctrl + Enter to send' }), send)));
    body.append(c);
    requestAnimationFrame(function () { thread.scrollTop = thread.scrollHeight; });
  }

  /* ================================================================ booking and pay */
  function tabBooking(body) {
    var a = A;
    var grid = el('div', { class: 'evd-grid' });
    var left = el('div', { class: 'evd-col' }), right = el('div', { class: 'evd-col' });
    grid.append(left, right);
    body.append(grid);
    var ho = a.handover || {};
    if (ho.setup) left.append(setupCard(a));
    if (a.invoices.length) a.invoices.forEach(function (inv) { left.append(invoiceCard(inv)); });
    else if (ho.paidBefore) left.append(el('div', { class: 'evd-card evd-empty is-ok' }, icon('check'), el('b', { text: 'Already paid for' }), el('p', { class: 'ev-muted', text: 'This table was paid for before it was passed to you, so there is nothing for you to pay.' })));
    else left.append(el('div', { class: 'evd-card evd-empty' }, icon('pound'), el('b', { text: a.status === 'approved' ? (ho.setup ? 'Your invoice comes next' : 'Your invoice is on its way') : 'No invoice yet' }), el('p', { class: 'ev-muted', text: a.status === 'approved' ? (ho.setup ? 'Once your details are in, the team sends your invoice. Your table is confirmed once it is paid.' : 'It comes by email and appears here. Your table is confirmed once it is paid.') : 'If we offer you a table, your invoice appears here and comes by email.' })));
    right.append(bookingCard(a));
    if (!ho.setup) right.append(detailsCard(a));
    var pass = passCard(a);
    if (pass) right.append(pass);
  }

  /* A table passed to them: their details, what they sell, the show's
     questions and the trader terms, in one form. Their name comes as the
     trader who passed it on gave it, for them to put right. */
  function setupCard(a) {
    var b = a.business, ev = a.event || {};
    var c = card('Your details', 'evd-setup', 'doc');
    c.append(el('p', { class: 'evd-setup__lede', text: 'Tell us who you are and what you will be selling. It goes to the team, onto your invoice, and onto the show page once you add your logo.' }));
    var form = {};
    var g = el('div', { class: 'evf-grid' });
    [['business_name', 'Trading name', b.name, 'organization'], ['contact_name', 'Your name', b.contact, 'name'], ['phone', 'Mobile number', b.phone, 'tel'],
      ['address_line1', 'Address', b.address.line1, 'address-line1'], ['address_line2', 'Address line 2 (optional)', b.address.line2, 'address-line2'], ['town', 'Town', b.address.town, 'address-level2'], ['postcode', 'Postcode', b.address.postcode, 'postal-code']].forEach(function (f) {
      var i = el('input', { class: 'evf-input', id: 'evs-' + f[0], autocomplete: f[3], type: f[0] === 'phone' ? 'tel' : 'text' });
      i.value = f[2] || '';
      form[f[0]] = i;
      g.append(el('div', { class: 'evf-field', 'data-f': f[0] }, el('label', { for: 'evs-' + f[0], text: f[1] }), i));
    });
    var cats = (a.categories || []).slice();
    var chips = el('div', { class: 'evf-chips eva-chips' });
    (ev.categories || []).forEach(function (cname) {
      var cb = el('input', { type: 'checkbox', value: cname });
      cb.checked = cats.indexOf(cname) > -1;
      cb.addEventListener('change', function () { cats = cats.filter(function (x) { return x !== cname; }); if (cb.checked) cats.push(cname); });
      chips.append(el('label', {}, cb, el('span', { text: cname })));
    });
    g.append(el('div', { class: 'evf-field is-wide', 'data-f': 'categories' }, el('span', { class: 'evf-label', text: 'You will be selling' }), chips));
    var stock = el('textarea', { class: 'evf-textarea', id: 'evs-bringing', maxlength: 1500, rows: 3, placeholder: 'For example: vintage singles, graded slabs, sealed booster boxes, binders of trades.' });
    stock.value = a.bringing || '';
    form.bringing = stock;
    g.append(el('div', { class: 'evf-field is-wide', 'data-f': 'bringing' }, el('label', { for: 'evs-bringing', text: 'Your stock' }), stock));
    var needs = el('textarea', { class: 'evf-textarea', id: 'evs-needs', maxlength: 800, rows: 2, placeholder: 'Power, a corner, anything that would help on the day.' });
    needs.value = a.needs || '';
    form.needs = needs;
    g.append(el('div', { class: 'evf-field is-wide', 'data-f': 'needs' }, el('label', { for: 'evs-needs', text: 'Anything you need (optional)' }), needs));
    var answers = {};
    (ev.questions || []).forEach(function (q) {
      var t = el('textarea', { class: 'evf-textarea', id: 'evs-q-' + q.id, maxlength: 800, rows: 2 });
      t.value = ((a.answers || {})[q.id] || {}).answer || '';
      answers[q.id] = t;
      g.append(el('div', { class: 'evf-field is-wide', 'data-f': 'answers.' + q.id }, el('label', { for: 'evs-q-' + q.id, text: q.label + (q.required ? '' : ' (optional)') }), t));
    });
    c.append(g);
    var tick = function (name, label, checked) {
      var cb = el('input', { type: 'checkbox', name: name });
      cb.checked = checked;
      form[name] = cb;
      return el('div', { 'data-f': name }, el('label', { class: 'evf-tick' }, cb, el('span', {}, label)));
    };
    c.append(el('div', { class: 'evf-consent' },
      tick('consent_terms', el('span', {}, 'I have read and agree to the ', el('a', { href: TRADERS + '#terms', target: '_blank', rel: 'noopener', text: 'trader terms' }), (a.termsVersion ? ' (' + a.termsVersion + ')' : '') + '.'), false),
      tick('consent_listing', el('span', {}, el('b', { text: 'List my business publicly' }), el('small', { text: ' On the show page and in Who\'s trading. Change it any time from Profile.' })), true),
      tick('consent_marketing', 'Email me when tables open for future shows.', false)));
    var save = btn('Save my details', 'ev-btn--primary', function () {
      var body = { categories: cats, answers: {} };
      Object.keys(form).forEach(function (k) { body[k] = form[k].type === 'checkbox' ? form[k].checked : form[k].value; });
      Object.keys(answers).forEach(function (k) { body.answers[k] = answers[k].value; });
      save.classList.add('is-busy');
      portal('update', { method: 'POST', body: body }).then(function (r) { EV.toast('Saved. Welcome aboard.'); render(r.application); })
        .catch(function (err) {
          save.classList.remove('is-busy');
          var first = null;
          c.querySelectorAll('[data-f]').forEach(function (w) {
            var old = w.querySelector(':scope > .evf-err');
            if (old) old.remove();
            var msg = err.fields && err.fields[w.getAttribute('data-f')];
            w.classList.toggle('has-error', !!msg);
            if (msg) { w.append(el('p', { class: 'evf-err', text: msg })); first = first || w; }
          });
          if (first) first.scrollIntoView({ block: 'center', behavior: EV.reduce.matches ? 'auto' : 'smooth' });
          EV.toast(err.message);
        });
    }, 'check');
    c.append(el('div', { class: 'evf-nav' }, save));
    return c;
  }

  /* Can't make it: ask to pass the table to another trader. The team
     approves it; until then the table stays theirs and they can cancel. */
  function passCard(a) {
    var ho = a.handover || {};
    if (a.status !== 'approved' || ho.setup) return null;
    var c = card('Can\'t make it?', 'evd-pass', 'users');
    if (ho.request) {
      var r = ho.request;
      c.classList.add('is-waiting');
      c.append(el('div', { class: 'evd-pass__wait' }, icon('clock'), el('div', null,
        el('b', { text: 'Waiting for the team' }),
        el('p', { text: 'You asked on ' + niceDate(r.at, { day: 'numeric', month: 'long' }) + ' to pass your table to ' + r.toBusiness + ' (' + r.toContact + ', ' + r.toEmail + '). It stays yours until the team approves it, and we email you both when it is decided.' }))));
      var cancel = btn('Cancel the request', 'ev-btn--sm', function () {
        cancel.classList.add('is-busy');
        portal('handover-cancel', { method: 'POST' }).then(function (x) { EV.toast('Request cancelled. The table stays yours.'); render(x.application); })
          .catch(function (err) { cancel.classList.remove('is-busy'); EV.toast(err.message); });
      });
      c.append(cancel);
      return c;
    }
    if (ho.declined) {
      c.append(el('div', { class: 'evd-pass__no' }, el('b', { text: 'The team did not approve passing your table to ' + ho.declined.toEmail + '.' }), ho.declined.note ? el('p', { text: ho.declined.note }) : null));
    }
    if (!ho.can) {
      c.append(el('p', { class: 'ev-muted', text: ho.why || 'Message the team and we will help.' }));
      return c;
    }
    c.append(el('p', { class: 'ev-muted', text: 'Pass your table to another trader. Tell us who they are and the team looks at it; until we approve it, the table stays yours.' }));
    var open = btn('Pass my table on', 'ev-btn--sm', null, 'users');
    var f = {};
    var fld = function (k, label, attrs, wide) {
      var i = el(attrs && attrs.rows ? 'textarea' : 'input', Object.assign({ class: attrs && attrs.rows ? 'evf-textarea' : 'evf-input', id: 'evh-' + k }, attrs || {}));
      f[k] = i;
      return el('div', { class: 'evf-field' + (wide ? ' is-wide' : ''), 'data-f': k }, el('label', { for: 'evh-' + k, text: label }), i);
    };
    var tick = el('input', { type: 'checkbox', id: 'evh-confirm' });
    var form = el('div', { class: 'evp-confirm evd-pass__form', hidden: true, role: 'group', 'aria-labelledby': 'evh-h' },
      el('h4', { id: 'evh-h', text: 'Who is taking your table?' }),
      el('div', { class: 'evf-grid' },
        fld('business', 'Their trading name', { autocomplete: 'off', maxlength: 120 }),
        fld('contact', 'Their name', { autocomplete: 'off', maxlength: 120 }),
        fld('email', 'Their email', { type: 'email', autocomplete: 'off', maxlength: 190 }),
        fld('email2', 'Their email again', { type: 'email', autocomplete: 'off', maxlength: 190 }),
        fld('selling', 'What they sell (optional)', { rows: 2, maxlength: 600 }, true),
        fld('note', 'A note to the team (optional)', { rows: 2, maxlength: 800, placeholder: 'Why you cannot make it, or how you know them.' }, true)),
      el('ul', { class: 'evd-pass__what' },
        el('li', { text: 'The team looks at it first. Until they approve it, the table is yours.' }),
        el('li', { text: 'Once approved, your table' + (a.booking.tableNo ? ' (table ' + a.booking.tableNo + ')' : '') + ' goes to them' + (a.confirmed ? ', already paid for: any money between you is for the two of you to settle.' : '. Any unpaid invoice of yours is cancelled, and they get their own.') }),
        el('li', { text: 'Your details, logo, listing and messages here are removed, and your link stops working.' }),
        el('li', { text: 'You, they and the team each get an email.' })),
      el('div', { 'data-f': 'confirm' }, el('label', { class: 'evf-tick' }, tick, el('span', { text: 'I understand. Send this to the team.' }))));
    var keep = btn('Keep my table', 'ev-btn--sm', null);
    var send = btn('Send to the team', 'ev-btn--primary ev-btn--sm', null, 'arrow', true);
    form.append(el('div', { class: 'evp-confirm__row' }, keep, send));
    open.addEventListener('click', function () { form.hidden = false; open.hidden = true; f.business.focus(); });
    keep.addEventListener('click', function () { form.hidden = true; open.hidden = false; open.focus(); });
    send.addEventListener('click', function () {
      var body = { confirm: tick.checked };
      Object.keys(f).forEach(function (k) { body[k] = f[k].value.trim(); });
      send.classList.add('is-busy');
      portal('handover', { method: 'POST', body: body }).then(function (x) { EV.toast('Sent to the team. We will email you when it is decided.'); render(x.application); })
        .catch(function (err) {
          send.classList.remove('is-busy');
          form.querySelectorAll('[data-f]').forEach(function (w) {
            var old = w.querySelector(':scope > .evf-err');
            if (old) old.remove();
            var msg = err.fields && err.fields[w.getAttribute('data-f')];
            w.classList.toggle('has-error', !!msg);
            if (msg) w.append(el('p', { class: 'evf-err', text: msg }));
          });
          EV.toast(err.message);
        });
    });
    c.append(open, form);
    return c;
  }
  function invoiceCard(inv) {
    var c = el('div', { class: 'evp-inv' });
    c.append(el('div', { class: 'evp-inv__head' },
      el('div', {}, el('b', { text: 'Invoice ' + inv.number }), el('span', { text: 'Issued ' + niceDate(inv.issueDate, { day: 'numeric', month: 'short', year: 'numeric' }) + ' · due ' + niceDate(inv.dueDate, { day: 'numeric', month: 'short', year: 'numeric' }) })),
      el('div', { class: 'evp-inv__amt', text: EV.money(inv.status === 'paid' ? inv.total : inv.balance) })));
    var tb = el('tbody');
    inv.lines.forEach(function (l) { tb.append(el('tr', {}, el('td', { text: l.description + (l.qty > 1 ? ' × ' + l.qty : '') }), el('td', { text: EV.money(l.amount) }))); });
    if (inv.vat > 0) tb.append(el('tr', {}, el('td', { text: (inv.vatMode === 'inclusive' ? 'Includes VAT ' : 'VAT ') + inv.vatRate + '%' }), el('td', { text: EV.money(inv.vat) })));
    if (inv.paid > 0 && inv.balance > 0) tb.append(el('tr', {}, el('td', { text: 'Paid so far' }), el('td', { text: '-' + EV.money(inv.paid) })));
    tb.append(el('tr', { class: 'is-total' }, el('td', { text: inv.balance > 0 ? 'To pay' : 'Total' }), el('td', { text: EV.money(inv.balance > 0 ? inv.balance : inv.total) })));
    c.append(el('table', {}, tb));
    if (inv.status === 'paid') c.append(el('span', { class: 'evp-paid', text: 'Paid, thank you' }));
    if (inv.status === 'overdue') c.append(el('span', { class: 'evp-paid is-overdue', text: 'Overdue: please pay as soon as you can' }));
    if (inv.status === 'void') c.append(el('span', { class: 'evp-paid', style: 'background:#efe8e0;color:#62513f', text: 'Cancelled' }));
    if (inv.notes) c.append(el('p', { style: 'margin:0;white-space:pre-wrap', text: inv.notes }));
    var offered = 0;
    inv.pay.forEach(function (p) {
      if (p.method === 'card') {
        offered++;
        var b = btn(p.label, 'ev-btn--primary ev-btn--block', function () {
          b.classList.add('is-busy');
          portal('pay', { method: 'POST', body: { invoice: inv.id } }).then(function (r) {
            if (r.paid) { EV.toast('This invoice is already paid'); load(); return; }
            if (r.url && /^https:\/\//.test(r.url)) location.href = r.url;
          }).catch(function (err) { b.classList.remove('is-busy'); EV.toast(err.message); });
        }, 'arrow', true);
        c.append(b, el('small', { style: 'color:var(--ev-paper-mute)', text: p.note }));
      } else if (p.method === 'xero' && /^https:\/\/in\.xero\.com\//.test(p.url || '')) {
        offered++;
        c.append(el('a', { class: 'ev-btn ev-btn--dark', href: p.url, target: '_blank', rel: 'noopener' }, p.label));
      } else if (p.method === 'bank' && p.details) {
        var dl = el('dl', { class: 'evp-bank' });
        [['Account name', p.details.account_name], ['Sort code', p.details.sort_code, 1], ['Account number', p.details.account_number, 1], ['Reference', p.details.reference, 1], ['Bank', p.details.bank]].forEach(function (r) {
          if (!r[1]) return;
          var dd = el('dd', {}, el('span', { text: r[1] }));
          if (r[2]) dd.append(el('button', { type: 'button', class: 'evp-copy', 'aria-label': 'Copy ' + r[0].toLowerCase(), text: 'Copy', onclick: function () { EV.copyText(r[0] === 'Reference' ? String(r[1]) : String(r[1]).replace(/[\s-]+/g, ''), r[0] + ' copied'); } }));
          dl.append(el('dt', { text: r[0] }), dd);
        });
        c.append(el('div', { style: 'display:grid;gap:8px' }, el('b', { text: offered ? 'Or pay by bank transfer' : 'Pay by bank transfer' }), dl, p.details.note ? el('small', { style: 'color:var(--ev-paper-mute)', text: p.details.note }) : null));
      }
    });
    if (inv.footer) c.append(el('small', { style: 'color:var(--ev-paper-mute)', text: inv.footer }));
    return c;
  }
  function bookingCard(a) {
    var ev = a.event || {};
    var c = card('Your booking', '', 'ticket');
    var t = (ev.tables || []).filter(function (x) { return x.id === a.booking.tableType; })[0];
    var dl = el('dl', { class: 'evp-facts' });
    var row = function (k, v) { if (v) dl.append(el('dt', { text: k }), el('dd', { text: v })); };
    row('Show', ev.title ? ev.title + ', ' + ev.dateLabel : '');
    row('Venue', [ev.venue, ev.town].filter(Boolean).join(', '));
    row('Table', t ? t.name + (a.booking.tableQty > 1 ? ' × ' + a.booking.tableQty : '') : '');
    row('Extras', (ev.extras || []).filter(function (x) { return a.booking.extras.indexOf(x.id) > -1; }).map(function (x) { return x.name; }).join(', '));
    row('Where', [a.booking.zone, a.booking.tableNo ? 'Table ' + a.booking.tableNo : ''].filter(Boolean).join(' · '));
    row('Reference', a.ref);
    c.append(dl);
    if (a.withdrawable) {
      var w = el('button', { type: 'button', class: 'evd-linkbtn', text: 'Withdraw my application', 'aria-expanded': 'false' });
      var why = el('textarea', { class: 'evf-textarea', maxlength: 500, placeholder: 'Optional. It helps us plan future shows.', id: 'evd-why', rows: 2 });
      var goB = btn('Yes, withdraw', 'ev-btn--danger ev-btn--sm', null);
      var keep = btn('Keep my application', 'ev-btn--sm', null);
      var p = el('div', { class: 'evp-confirm', hidden: true, role: 'group', 'aria-labelledby': 'evd-confirm-h' },
        el('h4', { id: 'evd-confirm-h', text: 'Withdraw this application?' }),
        el('p', { text: a.status === 'approved' ? 'Your table goes back to the pool. If you have paid, we will be in touch about a refund under the trader terms.' : 'We stop reviewing it. You can apply again while applications are open.' }),
        el('label', { for: 'evd-why', text: 'Tell us why' }), why, el('div', { class: 'evp-confirm__row' }, keep, goB));
      w.addEventListener('click', function () { p.hidden = false; w.hidden = true; why.focus(); });
      keep.addEventListener('click', function () { p.hidden = true; w.hidden = false; w.focus(); });
      goB.addEventListener('click', function () {
        goB.classList.add('is-busy');
        portal('withdraw', { method: 'POST', body: { reason: why.value.trim() } }).then(function (r) { EV.toast('Withdrawn. Thank you for letting us know.'); render(r.application); })
          .catch(function (err) { goB.classList.remove('is-busy'); EV.toast(err.message); });
      });
      c.append(w, p);
    }
    return c;
  }
  function detailsCard(a) {
    var b = a.business;
    var c = card('Your details', '', 'doc');
    var dl = el('dl', { class: 'evp-facts' });
    var row = function (k, v) { if (v) dl.append(el('dt', { text: k }), el('dd', { text: v })); };
    row('Contact', b.contact);
    row('Email', b.email);
    row('Phone', b.phone);
    row('Address', [b.address.line1, b.address.line2, b.address.town, b.address.postcode].filter(Boolean).join(', '));
    row('Selling', a.categories.join(', '));
    row('Stock', a.bringing);
    c.append(dl);
    if (!a.editable) { c.append(el('p', { class: 'ev-muted ev-small' }, 'Need to change something? ', el('a', { href: '#tab=messages', 'data-evd-go': 'messages', text: 'Send us a message' }), '.')); return c; }
    c.append(btn('Change my details', 'ev-btn--sm', function () {
      c.textContent = '';
      c.append(el('h2', { class: 'evd-card__h', text: 'Change your details' }));
      var form = {};
      var g = el('div', { class: 'evf-grid' });
      [['business_name', 'Trading name', b.name], ['contact_name', 'Your name', b.contact], ['phone', 'Mobile number', b.phone],
        ['address_line1', 'Address', b.address.line1], ['address_line2', 'Address line 2', b.address.line2], ['town', 'Town', b.address.town], ['postcode', 'Postcode', b.address.postcode]].forEach(function (f) {
        var i = el('input', { class: 'evf-input', id: 'evd-' + f[0] });
        i.value = f[2] || '';
        form[f[0]] = i;
        g.append(el('div', { class: 'evf-field', 'data-f': f[0] }, el('label', { for: 'evd-' + f[0], text: f[1] }), i));
      });
      var stock = el('textarea', { class: 'evf-textarea', id: 'evd-bringing', maxlength: 1500 });
      stock.value = a.bringing || '';
      form.bringing = stock;
      g.append(el('div', { class: 'evf-field is-wide', 'data-f': 'bringing' }, el('label', { for: 'evd-bringing', text: 'Your stock' }), stock));
      c.append(g);
      var save = btn('Save changes', 'ev-btn--primary', function () {
        var body = {};
        Object.keys(form).forEach(function (k) { body[k] = form[k].value; });
        save.classList.add('is-busy');
        portal('update', { method: 'POST', body: body }).then(function (r) { EV.toast('Saved'); render(r.application); })
          .catch(function (err) {
            save.classList.remove('is-busy');
            c.querySelectorAll('[data-f]').forEach(function (w) { var old = w.querySelector('.evf-err'); if (old) old.remove(); if (err.fields && err.fields[w.getAttribute('data-f')]) w.append(el('p', { class: 'evf-err', text: err.fields[w.getAttribute('data-f')] })); });
            EV.toast(err.message);
          });
      }, 'check');
      c.append(el('div', { class: 'evf-nav' }, btn('Cancel', '', function () { paintBody(); }), save));
    }, 'edit'));
    return c;
  }

  /* ================================================================ show day */
  function lockedPanel(body, ic, title, text) {
    body.append(el('div', { class: 'evd-locked' }, el('span', { class: 'evd-locked__ic' }, icon('lock'), icon(ic)), el('h2', { class: 'ev-display', text: title }), el('p', { text: text }), btn('Back to overview', '', function () { go('overview', true); })));
  }
  function tabShowday(body) {
    var a = A, ev = a.event || {}, sh = show();
    if (a.status !== 'approved') { lockedPanel(body, 'stall', 'Show day opens with your table', 'Arrival times, your table number and packing down appear here once we offer you a table.'); return; }
    if (!isDone('info')) track('info');
    var t = (ev.tables || []).filter(function (x) { return x.id === a.booking.tableType; })[0];
    var hero = el('section', { class: 'evd-table' },
      el('div', null, el('span', { class: 'evd-hero__k', text: 'Your table' }),
        el('b', { class: 'ev-display evd-table__no', text: a.booking.tableNo ? a.booking.tableNo : 'TBC' }),
        el('span', { text: a.booking.zone ? a.booking.zone : a.booking.tableNo ? '' : 'We allocate tables nearer the day; it appears here and in your run-down email.' })),
      el('dl', { class: 'evd-table__facts' },
        el('div', null, el('dt', { text: 'Date' }), el('dd', { text: niceDate(ev.startsAt) })),
        el('div', null, el('dt', { text: 'Doors' }), el('dd', { text: ev.startsAt ? new Date(ev.startsAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) + (ev.endsAt ? ' to ' + new Date(ev.endsAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '') : 'TBC' })),
        el('div', null, el('dt', { text: 'Booked' }), el('dd', { text: t ? t.name + (a.booking.tableQty > 1 ? ' × ' + a.booking.tableQty : '') : '' }))));
    body.append(hero);
    var info = (ev.info || {});
    var cards = el('div', { class: 'evd-infos' });
    [['trader_arrival', 'Arrival and set-up', 'clock'], ['packdown', 'Packing down', 'box'], ['included', 'With your table', 'check'], ['notes', 'Good to know', 'info']].forEach(function (k) {
      if (info[k[0]]) cards.append(el('article', { class: 'evd-info' }, el('span', { class: 'evd-info__ic' }, icon(k[2])), el('h3', { text: k[1] }), el('p', { text: info[k[0]] })));
    });
    if (cards.childNodes.length) body.append(cards);
    var addr = [ev.venue, sh.address, ev.town, sh.postcode].filter(Boolean).join(', ');
    var venue = card('The venue', 'evd-venue', 'pin');
    venue.append(el('p', { class: 'evd-venue__a', text: addr || 'To be confirmed' }));
    var row = el('div', { class: 'ev-cta-row' });
    if (addr) row.append(el('a', { class: 'ev-btn ev-btn--sm', href: 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addr), target: '_blank', rel: 'noopener' }, icon('car'), 'Directions'));
    if (ev.startsAt) {
      row.append(btn('Add to calendar', 'ev-btn--sm', function () {
        var f = function (iso) { var d = new Date(iso); var p = function (n) { return (n < 10 ? '0' : '') + n; }; return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + 'T' + p(d.getHours()) + p(d.getMinutes()) + '00'; };
        EV.downloadIcs({ name: 'Trading at ' + ev.title, start: f(ev.startsAt), end: ev.endsAt ? f(ev.endsAt) : '', where: addr, url: sh.url || location.origin });
      }, 'cal'));
    }
    if (sh.url) row.append(el('a', { class: 'ev-btn ev-btn--sm', href: sh.url }, icon('ext'), 'Show page'));
    venue.append(row);
    body.append(venue);
    var wa = safe(a.team && a.team.whatsapp, /^https:\/\/wa\.me\//);
    body.append(el('div', { class: 'evd-help' }, icon('info'), el('span', null, 'Running late or stuck on the day? ', wa ? el('a', { href: wa, target: '_blank', rel: 'noopener', text: 'Message the team on WhatsApp' }) : el('a', { href: '#tab=messages', 'data-evd-go': 'messages', text: 'Message the team' }), '.')));
  }

  /* ================================================================ promo kit */
  function tabKit(body) {
    var a = A;
    if (a.status !== 'approved') { lockedPanel(body, 'poster', 'Your promo kit opens with your table', 'Once we offer you a table, posters drawn with your logo appear here, ready for Instagram, stories, Facebook and print.'); return; }
    var mountAt = el('div', { class: 'evk-mount' });
    body.append(mountAt);
    if (!window.EVKit) { mountAt.append(el('p', { class: 'ev-muted', text: 'The poster maker is loading.' })); setTimeout(function () { if (tab === 'kit') paintBody(); }, 600); return; }
    window.EVKit.mount(mountAt, {
      app: a, show: show(), shop: root.getAttribute('data-shop') || location.origin, wall: root.getAttribute('data-wall') || '',
      dirUrl: DIR, loadLogo: function () { return portal('kit').then(function (r) { return r.logo || ''; }); },
      track: track
    });
    if (a.pack && a.pack.length) body.append(packCard(a.pack));
  }
  function packCard(pack) {
    var KIND = { image: ['Image', 'img'], pdf: ['PDF', 'doc'], zip: ['Zip', 'box'], doc: ['Doc', 'doc'], link: ['Link', 'link'] };
    var c = card('From the show: the trader pack', 'evd-pack', 'box');
    c.append(el('p', { class: 'ev-muted', text: 'Official posters, signage and set-up files for the show. Share the posters wherever you like.' }));
    var list = el('div', { class: 'evp-pack' });
    pack.forEach(function (r) {
      if (!/^https:\/\//i.test(r.url || '')) return;
      var k = KIND[r.kind] || KIND.link;
      var media = el('span', { class: 'evp-pack__media' });
      if (r.thumb && /^https:\/\//i.test(r.thumb)) media.append(el('img', { src: r.thumb, alt: '', loading: 'lazy', decoding: 'async' }));
      else media.append(icon(k[1]));
      list.append(el('a', { class: 'evp-pack__item', href: r.url, target: '_blank', rel: 'noopener' }, media, el('span', { class: 'evp-pack__tx' }, el('b', { text: r.title }), r.note ? el('small', { text: r.note }) : null), el('span', { class: 'evp-pack__kind' }, k[0], icon('ext'))));
    });
    c.append(list);
    return c;
  }

  /* ================================================================ traders' group */
  function tabGroup(body) {
    var a = A, wa = a.whatsapp || { state: 'none' };
    var teamWa = safe(a.team && a.team.whatsapp, /^https:\/\/wa\.me\//);
    if (wa.state === 'open') {
      var url = safe(wa.url, /^https:\/\/(chat\.whatsapp\.com|whatsapp\.com\/channel)\/[A-Za-z0-9]+$/);
      var joined = isDone('whatsapp');
      var join = el('a', { class: 'ev-btn ev-btn--wa evd-wa__join', href: url, target: '_blank', rel: 'noopener' }, icon('whatsapp'), joined ? 'Open the group' : 'Join the group');
      join.addEventListener('click', function () { track('whatsapp'); });
      var qr = el('div', { class: 'evd-wa__qr' });
      try { qr.append(EV.qrSvg(url, { label: 'QR code to join the group', fg: '#0b2b18' })); } catch (e) { /* too long, never for a group link */ }
      qr.append(el('small', { text: 'On a computer? Scan with your phone.' }));
      var rules = el('ul', { class: 'evd-wa__rules' });
      String(wa.rules || '').split(/\n+/).map(function (s) { return s.trim(); }).filter(Boolean).forEach(function (r) { rules.append(el('li', null, icon('check'), el('span', { text: r }))); });
      body.append(el('section', { class: 'evd-wa' },
        el('div', { class: 'evd-wa__tx' },
          el('span', { class: 'evd-wa__badge' }, icon('whatsapp'), wa.kind === 'channel' ? 'WhatsApp channel' : 'WhatsApp group'),
          el('h2', { class: 'ev-display', text: "The traders' group" }),
          el('p', { text: 'Every trader at ' + (a.event ? a.event.title : 'the show') + ' and the team, in one place: set-up news on the day, lifts and parking, swaps, and the odd emergency roll of tape.' }),
          joined ? el('p', { class: 'evd-wa__joined' }, icon('check'), 'You opened the invite on ' + niceDate(wa.joinedAt, { day: 'numeric', month: 'long' }) + '.') : null,
          el('div', { class: 'ev-cta-row' }, join),
          rules.childNodes.length ? el('div', { class: 'evd-wa__rulebox' }, el('b', { text: 'Group rules' }), rules) : null,
          el('p', { class: 'ev-small evd-wa__keep', text: 'Please keep the link to yourself: the group is only for traders with a table.' })),
        qr));
    } else if (wa.state === 'locked') {
      body.append(el('section', { class: 'evd-wa is-locked' },
        el('div', { class: 'evd-wa__tx' }, el('span', { class: 'evd-wa__badge' }, icon('lock'), 'Locked'), el('h2', { class: 'ev-display', text: "The traders' group" }),
          el('p', { text: wa.hint || 'It opens once your table is confirmed.' }),
          unpaid(a).length ? btn('Pay to unlock it', 'ev-btn--primary', function () { go('booking', true); }, 'arrow', true) : null),
        el('div', { class: 'evd-wa__ghost', 'aria-hidden': 'true' }, el('span', { class: 'in', text: 'Trader doors open at 8' }), el('span', { class: 'out', text: 'Anyone got a spare extension lead?' }), el('span', { class: 'in', text: 'Table B3 has one' }))));
    } else {
      body.append(el('div', { class: 'evd-card evd-empty' }, icon('whatsapp'), el('b', { text: 'No traders\' group for this show yet' }), el('p', { class: 'ev-muted', text: 'If we set one up, the invite appears here and comes by email.' })));
    }
    var team = card('Talk to the team', 'evd-team', 'chat');
    team.append(el('p', { class: 'ev-muted', text: 'Something just for you? Message us privately.' }));
    var r = el('div', { class: 'ev-cta-row' });
    if (teamWa) r.append(el('a', { class: 'ev-btn ev-btn--wa ev-btn--sm', href: teamWa, target: '_blank', rel: 'noopener' }, icon('whatsapp'), 'WhatsApp the team'));
    r.append(el('a', { class: 'ev-btn ev-btn--sm', href: '#tab=messages', 'data-evd-go': 'messages' }, icon('chat'), 'Message from here'));
    if (a.team && a.team.email) r.append(el('a', { class: 'ev-btn ev-btn--sm', href: 'mailto:' + a.team.email }, icon('mail'), a.team.email));
    team.append(r);
    body.append(team);
  }

  /* ================================================================ profile */
  function tabProfile(body) {
    var a = A, b = a.business;
    // an older desk sends no listing block: treat the listing as not live yet
    var L = a.listing || { live: false, hiddenByTeam: false, pageUrl: '' };
    var ended = ['declined', 'withdrawn', 'cancelled'].indexOf(a.status) > -1;
    var grid = el('div', { class: 'evd-grid evd-grid--profile' });
    var formCard = card('Your public listing', 'evd-listing', 'users');
    var prevCard = card('How visitors see you', 'evd-prev', 'globe');
    grid.append(formCard, prevCard);
    body.append(grid);
    var state = { blurb: a.blurb || '', website: b.website || '', instagram: (b.socials || {}).instagram || '', tiktok: (b.socials || {}).tiktok || '', facebook: (b.socials || {}).facebook || '', listed: !!a.consentListing };
    function paintPrev(logoUrl) {
      prevCard.querySelectorAll(':scope > :not(h2)').forEach(function (n) { n.remove(); });
      var v = EV.vendorFrom({ name: b.name, logo: logoUrl || b.logo, categories: a.categories, blurb: state.blurb.trim(), tier: a.tier ? a.tier.key : '', tierName: a.tier ? a.tier.name : '', zone: a.booking.zone || '', table: a.booking.tableNo || '', website: state.website, socials: {} });
      prevCard.append(EV.vendorCard(v, function () { EV.vendorDialog(v, { event: a.event ? a.event.title : '', url: L.pageUrl }); }));
      if (v.blurb) prevCard.append(el('p', { class: 'evd-prev__blurb', text: v.blurb }));
      prevCard.append(el('p', { class: 'evd-prev__state ' + (L.live ? 'is-live' : '') }, icon(L.live ? 'check' : 'lock'),
        L.live ? 'Live on the show page now.' : L.hiddenByTeam ? 'Hidden by the team. Message us if that is a surprise.' : !state.listed ? 'You have chosen not to be listed.' : a.status === 'approved' ? 'Listed as soon as you say yes below.' : 'Listed once your table is confirmed.'));
      if (L.live && L.pageUrl) {
        prevCard.append(el('div', { class: 'ev-cta-row' },
          el('a', { class: 'ev-btn ev-btn--sm', href: L.pageUrl }, icon('ext'), 'See it'),
          btn('Share my listing', 'ev-btn--sm', function () {
            EV.share({ url: L.pageUrl, short: traderShort(a), title: b.name + ' at ' + (a.event ? a.event.title : 'the show'), text: 'Find ' + b.name + ' at ' + (a.event ? a.event.title : 'the show') + (a.booking.tableNo ? ', table ' + a.booking.tableNo : '') + '. See you there!', sub: a.event ? a.event.dateLabel : '', image: b.logo, hashtags: (a.kit && a.kit.hashtags) || '', campaign: 'trader-listing', heading: 'Share your listing', onShare: function () { track('share'); } });
          }, 'share')));
      }
    }
    // logo
    var logoBox = el('div', { class: 'evf-logo__box eva-logo', tabindex: '0', role: 'button', 'aria-label': 'Change your logo' });
    var file = el('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/gif', class: 'ev-sr', 'aria-label': 'Logo file' });
    var paintLogo = function (src) { logoBox.textContent = ''; if (src) logoBox.append(el('img', { src: src, alt: 'Your logo' }), el('span', { class: 'eva-logo__swap', text: 'Change' })); else logoBox.append(icon('img'), el('b', { text: 'Add your logo' }), el('span', { text: 'Tap to choose' })); };
    paintLogo(b.logo);
    var upload = function (f) {
      if (!f) return;
      if (!/^image\/(png|jpeg|webp|gif)$/.test(f.type)) { EV.toast('Use a PNG, JPG, WebP or GIF'); return; }
      if (f.size > 6 * 1024 * 1024) { EV.toast('Logos must be under 6 MB'); return; }
      var local = URL.createObjectURL(f);
      paintLogo(local);
      logoBox.classList.add('is-busy');
      var fd = new FormData();
      fd.append('logo', f, f.name);
      portal('logo', { method: 'POST', body: fd }).then(function (r) { A = r.application; b = A.business; EV.toast('New logo saved'); logoBox.classList.remove('is-busy'); paintPrev(); paintTop(); })
        .catch(function (err) { logoBox.classList.remove('is-busy'); paintLogo(b.logo); EV.toast(err.message); });
    };
    if (!ended) {
      logoBox.addEventListener('click', function () { file.click(); });
      logoBox.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); file.click(); } });
      logoBox.addEventListener('dragover', function (e) { e.preventDefault(); logoBox.classList.add('is-drag'); });
      logoBox.addEventListener('dragleave', function () { logoBox.classList.remove('is-drag'); });
      logoBox.addEventListener('drop', function (e) { e.preventDefault(); logoBox.classList.remove('is-drag'); upload(e.dataTransfer.files[0]); });
      file.addEventListener('change', function () { upload(file.files[0]); });
    }
    formCard.append(el('div', { class: 'evf-field' }, el('span', { class: 'evf-label', text: 'Logo' }), el('div', { class: 'evf-logo' }, logoBox, el('p', { class: 'ev-muted ev-small', text: 'Square works best. It also goes on your promo posters.' })), file));
    var fields = {};
    var mk = function (k, label, attrs, wide, ta) {
      var i = el(ta ? 'textarea' : 'input', Object.assign({ class: ta ? 'evf-textarea' : 'evf-input', id: 'evd-p-' + k }, attrs || {}));
      i.value = state[k];
      i.addEventListener('input', function () { state[k] = i.value; if (k === 'blurb') { cnt.textContent = i.value.length + ' / 280'; paintPrev(); } });
      fields[k] = i;
      return el('div', { class: 'evf-field' + (wide ? ' is-wide' : ''), 'data-f': k }, el('label', { for: 'evd-p-' + k, text: label }), i);
    };
    var cnt = el('small', { class: 'eva-count', text: state.blurb.length + ' / 280' });
    var bw = mk('blurb', 'A line about you', { maxlength: 280, rows: 3, placeholder: 'What visitors will find at your table.' }, true, true);
    bw.append(cnt);
    formCard.append(bw);
    var g = el('div', { class: 'evf-grid' });
    g.append(mk('website', 'Website', { inputmode: 'url', placeholder: 'yourshop.co.uk' }), mk('instagram', 'Instagram', { placeholder: '@yourshop' }), mk('tiktok', 'TikTok', { placeholder: '@yourshop' }), mk('facebook', 'Facebook', { placeholder: 'facebook.com/yourshop' }));
    formCard.append(g);
    var lc = el('input', { type: 'checkbox' });
    lc.checked = state.listed;
    lc.addEventListener('change', function () { state.listed = lc.checked; paintPrev(); });
    formCard.append(el('label', { class: 'evf-tick eva-switch' }, lc, el('span', null, el('b', { text: 'List my business publicly' }), el('small', { text: "On the show page and in Who's trading, while my table is confirmed." }))));
    var save = btn('Save my listing', 'ev-btn--primary', function () {
      save.classList.add('is-busy');
      formCard.querySelectorAll('.evf-err').forEach(function (n) { n.remove(); });
      portal('profile', { method: 'POST', body: { blurb: state.blurb, website: state.website, instagram: state.instagram, tiktok: state.tiktok, facebook: state.facebook, listed: state.listed } })
        .then(function (r) { A = r.application; b = A.business; save.classList.remove('is-busy'); EV.toast('Listing saved'); paintPrev(); paintTabs(); })
        .catch(function (err) {
          save.classList.remove('is-busy');
          Object.keys(err.fields || {}).forEach(function (k) { var w = formCard.querySelector('[data-f="' + k + '"]'); if (w) w.append(el('p', { class: 'evf-err', role: 'alert', text: err.fields[k] })); });
          EV.toast(err.message);
        });
    }, 'check');
    if (ended) { formCard.querySelectorAll('input, textarea').forEach(function (n) { n.disabled = true; }); formCard.append(el('p', { class: 'ev-muted', text: 'This application has ended, so the listing cannot be changed.' })); }
    else formCard.append(el('div', { class: 'evf-nav' }, el('span', { class: 'ev-muted ev-small', text: 'Changes show on the show page within a few minutes.' }), save));
    paintPrev();

    // this device
    var dev = card('This device', 'evd-device', 'lock');
    var keep = el('input', { type: 'checkbox' });
    try { keep.checked = !!localStorage.getItem(KEEP_KEY); } catch (e) { keep.disabled = true; }
    keep.addEventListener('change', function () {
      try { if (keep.checked) localStorage.setItem(KEEP_KEY, token); else localStorage.removeItem(KEEP_KEY); } catch (e) { /* ignore */ }
      EV.toast(keep.checked ? 'You stay signed in on this device' : 'Signed in for this visit only');
    });
    dev.append(el('label', { class: 'evf-tick eva-switch' }, keep, el('span', null, el('b', { text: 'Keep me signed in on this device' }), el('small', { text: 'Only on a phone or computer that is yours alone.' }))),
      btn('Sign out here', 'ev-btn--sm', signOut, 'out'));
    body.append(dev);
  }

  /* ================================================================ go */
  if (!API) { showGate('The events desk is not set up for this page.', true); return; }
  if (takeHashToken()) { load(true); return; }
  var m0 = location.hash.match(/^#tab=([a-z]+)$/);
  if (m0) tab = m0[1];
  token = savedToken();
  if (token) load(true); else showGate();
})();
